module.exports = __webpack_public_path__ + "img/view-arrow.393cb7db.svg";